<template>
  <div class="btn-layer" v-if="list.length > 0">
    <div class="icon-layer" v-for="item in list" @click="clickTab(item)">
      <div v-if="!item.html" class="icon">
        <img v-lazy="item.src" />
      </div>
      <div v-if="!item.html" class="name">{{item.name}}</div>
      <div v-if="item.html" style="width:100%;" v-html="item.html"></div>
    </div>

    <div class="scrim-layer" v-show="showProject">
      <div class="box-layer" :class="{'animation': showProject}">
        <div class="close_btn" @click="closeScrim()"></div>
        <div class="item-layer">
          <div class="item border-bottom" v-for="project in prolist">
            <img v-lazy="project.banner_imgurl" />
            <div class="right-layer">
              <div class="title">{{project.extinfo.buildingName}}</div>
              <div class="mobile" @click="makeCall(project)">一键致电</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox } from "mint-ui";
export default {
  components: {},
  props: {
    prolist: Array,
  },
  data() {
    return {
      showProject: false,
      list: "",
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "pageInfo",
      "rsCardInfo",
      "userInfo",
      "receiveSpreadInfo",
    ]),
  },
  methods: {
    clickTab(item) {
      if (item.type == "link") {
        if (item.name.indexOf("找房") > -1 && util.checkIsHuafa()) {
          let cacheKey = `t9_page_search_tag`;
          util.setTimeStorage(cacheKey, "", 1);
          util.openYqRsMakeLink(
            `${location.protocol}//${location.host}/h5/t9_search`
          );
        } else if (item.url) {
          util.openOtherLink(item.url);
        } else {
          return MessageBox.alert("敬请期待");
        }
      } else if (item.type == "methods") {
        this[item.value]();
      }
    },
    clickWyzx() {
      comreq.actAdv(this, this.$enumUserEvent.call);
      if (this.$rscuid && this.rsCardInfo && this.rsCardInfo.mobile) {
        util.makePhoneCall(this.rsCardInfo.mobile);
      } else {
        console.log(this.pageInfo.Templateno);
        if (this.pageInfo.Templateno == 9) {
          this.showProject = true;
          // if (this.pageInfo.Tel) {
          //   util.makePhoneCall(this.pageInfo.Tel);
          // } else {
          //   MessageBox.alert("暂无电话", "提示");
          // }
        } else {
          if (this.pageInfo.Extinfo.projectTel) {
            util.makePhoneCall(this.pageInfo.Extinfo.projectTel);
          } else {
            MessageBox.alert("暂无电话", "提示");
          }
        }
      }
    },
    makeCall(item) {
      if (item.extinfo.projectTel) {
        console.log(item.extinfo.projectTel);
        util.makePhoneCall(item.extinfo.projectTel);
      } else {
        MessageBox.alert("暂无电话", "提示");
      }
    },
    closeScrim() {
      this.showProject = false;
    },
    getMpObj(name, icon, path, defaultIcon) {
      path = util.handleH5OpenMpPath(path);
      let script = document.createElement("script");
      script.type = "text/wxtag-template";
      script.text = `<img style="width:64%;margin-left:18%;display:block;margin-top:0.1rem" data-src="${
        icon || defaultIcon
      }" src="${
        icon || defaultIcon
      }" lazy="loaded"><div class="name" style="font-size:12px;color: #636a7a;text-align: center;margin-top:0.2rem" >${name}</div>`;
      let html = `<wx-open-launch-weapp style="width:100%;display:block;" username="${util.getOriginalId()}" path="${path}">${
        script.outerHTML
      }</wx-open-launch-weapp>`;
      return {
        name: name,
        html: html,
      };
    },
  },
  created() {},
  mounted() {
    //获取当前城市
    util
      .checkMapStateCallback(this, [
        "pageInfo",
        "userInfo",
        "receiveSpreadInfo",
      ])
      .then(() => {
        let icons = [];
        if (util.checkIsHuafa() || util.checkIsAlej()) {
          icons = [
            "https://assets.rurushishi.com/yq-rs-make/huafa/icon_fdjs.png",
            "https://assets.rurushishi.com/yq-rs-make/huafa/icon_wyzx.png",
            "https://assets.rurushishi.com/yq-rs-make/huafa/icon_jchd.png",
            "https://assets.rurushishi.com/yq-rs-make/huafa/icon_yhqg.png",
            "https://assets.rurushishi.com/yq-rs-make/huafa/icon_jczb.png",
            "https://assets.rurushishi.com/yq-rs-make/huafa/icon_zdy.png",
          ];
        } else if (util.checkIsZd()) {
          icons = [
            "https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_fdjs.png",
            "https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_wyzx.png",
            "https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_jchd.png",
            "https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_yhqg.png",
            "https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_jczb.png",
            "https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_jchd.png",
          ];
        } else {
          icons = [
            "https://assets.rurushishi.com/yq-rs-make/t9/tab/icon_fdjs2.png",
            "https://assets.rurushishi.com/yq-rs-make/t9/tab/icon_zdy2.png",
            "https://assets.rurushishi.com/yq-rs-make/t9/tab/icon_jchd2.png",
            "https://assets.rurushishi.com/yq-rs-make/t9/tab/icon_yhqg2.png",
            "https://assets.rurushishi.com/yq-rs-make/t9/tab/icon_jczb2.png",
            "https://assets.rurushishi.com/yq-rs-make/t9/tab/icon_zdy2.png",
          ];
        }

        if (this.pageInfo.Extinfo && this.pageInfo.Extinfo.tabConfig) {
          let tmp = [];
          // lj37
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_fdjs &&
            this.pageInfo.Extinfo.tabConfig.tabs_fdjs == 1
          ) {
            tmp.push({
              name: "房贷计算",
              src: icons[0],
              type: "link",
              url: `${location.protocol}//${location.host}/activities/housing-loan/index.html`,
            });
          }
          // lj38
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_wyzx &&
            this.pageInfo.Extinfo.tabConfig.tabs_wyzx == 1
          ) {
            tmp.push({
              name: "我要咨询",
              src: icons[1],
              type: "methods",
              value: "clickWyzx",
            });
          }
          // lj39
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_jchd &&
            this.pageInfo.Extinfo.tabConfig.tabs_jchd == 1
          ) {
            tmp.push({
              name: "精彩活动",
              src: icons[2],
              type: "link",
              url: `${this.pageInfo.Extinfo.tabConfig.jchd_link}`,
            });
          }
          // lj40
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_yhqg &&
            this.pageInfo.Extinfo.tabConfig.tabs_yhqg == 1
          ) {
            if (util.checkIsHuafa()) {
              let redirect_urlParam = util.getParamFromUrl(
                this.pageInfo.Extinfo.tabConfig.yhqg_link
              );

              let script = document.createElement("script");
              script.type = "text/wxtag-template";
              script.text = `<img style="width:64%;margin-left:18%;display:block;margin-top:0.1rem" data-src="${icons[3]}" src="${icons[3]}" lazy="loaded"><div class="name" style="font-size:12px;color: #636a7a;text-align: center;margin-top:0.2rem" >优惠抢购</div>`;
              let html = `<wx-open-launch-weapp style="width:100%;display:block;" username="${util.getOriginalId()}" path="${util.getXcxActAreasPath(
                this,
                "buy",
                redirect_urlParam.id,
                redirect_urlParam.psn
              )}">${script.outerHTML}</wx-open-launch-weapp>`;
              tmp.push({
                name: "优惠抢购",
                html: html,
              });
            } else {
              tmp.push({
                name: "优惠抢购",
                src: icons[3],
                type: "link",
                url: `${this.pageInfo.Extinfo.tabConfig.yhqg_link}`,
              });
            }
          }
          // lj41
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_jxzb &&
            this.pageInfo.Extinfo.tabConfig.tabs_jxzb == 1
          ) {
            if (util.checkIsHuafa() && this.isInMiniProgram) {
              //华发小程序不展示直播按钮
            } else {
              tmp.push({
                name: "精彩直播",
                src: icons[4],
                type: "link",
                url: `${this.pageInfo.Extinfo.tabConfig.jxzb_link}`,
              });
            }
          }
          // lj42
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_zdy1 &&
            this.pageInfo.Extinfo.tabConfig.tabs_zdy1 == 1
          ) {
            if (this.pageInfo.Extinfo.tabConfig.zdy1_link_mp) {
              tmp.push(
                this.getMpObj(
                  this.pageInfo.Extinfo.tabConfig.zdy1_name,
                  this.pageInfo.Extinfo.tabConfig.zdy1_icon,
                  this.pageInfo.Extinfo.tabConfig.zdy1_link_mp,
                  icons[5]
                )
              );
            } else {
              tmp.push({
                name: `${this.pageInfo.Extinfo.tabConfig.zdy1_name}`,
                src: this.pageInfo.Extinfo.tabConfig.zdy1_icon
                  ? this.pageInfo.Extinfo.tabConfig.zdy1_icon
                  : icons[5],
                type: "link",
                url: `${this.pageInfo.Extinfo.tabConfig.zdy1_link}`,
              });
            }
          }
          // lj43
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_zdy2 &&
            this.pageInfo.Extinfo.tabConfig.tabs_zdy2 == 1
          ) {
            if (this.pageInfo.Extinfo.tabConfig.zdy2_link_mp) {
              tmp.push(
                this.getMpObj(
                  this.pageInfo.Extinfo.tabConfig.zdy2_name,
                  this.pageInfo.Extinfo.tabConfig.zdy2_icon,
                  this.pageInfo.Extinfo.tabConfig.zdy2_link_mp,
                  icons[5]
                )
              );
            } else {
              tmp.push({
                name: `${this.pageInfo.Extinfo.tabConfig.zdy2_name}`,
                src: this.pageInfo.Extinfo.tabConfig.zdy2_icon
                  ? this.pageInfo.Extinfo.tabConfig.zdy2_icon
                  : icons[5],
                type: "link",
                url: `${this.pageInfo.Extinfo.tabConfig.zdy2_link}`,
              });
            }
          }
          // lj44
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_zdy3 &&
            this.pageInfo.Extinfo.tabConfig.tabs_zdy3 == 1
          ) {
            if (this.pageInfo.Extinfo.tabConfig.zdy3_link_mp) {
              tmp.push(
                this.getMpObj(
                  this.pageInfo.Extinfo.tabConfig.zdy3_name,
                  this.pageInfo.Extinfo.tabConfig.zdy3_icon,
                  this.pageInfo.Extinfo.tabConfig.zdy3_link_mp,
                  icons[5]
                )
              );
            } else {
              tmp.push({
                name: `${this.pageInfo.Extinfo.tabConfig.zdy3_name}`,
                src: this.pageInfo.Extinfo.tabConfig.zdy3_icon
                  ? this.pageInfo.Extinfo.tabConfig.zdy3_icon
                  : icons[5],
                type: "link",
                url: `${this.pageInfo.Extinfo.tabConfig.zdy3_link}`,
              });
            }
          }
          // lj45
          if (
            this.pageInfo.Extinfo.tabConfig.tabs_zdy4 &&
            this.pageInfo.Extinfo.tabConfig.tabs_zdy4 == 1
          ) {
            if (this.pageInfo.Extinfo.tabConfig.zdy4_link_mp) {
              tmp.push(
                this.getMpObj(
                  this.pageInfo.Extinfo.tabConfig.zdy4_name,
                  this.pageInfo.Extinfo.tabConfig.zdy4_icon,
                  this.pageInfo.Extinfo.tabConfig.zdy4_link_mp,
                  icons[5]
                )
              );
            } else {
              tmp.push({
                name: `${this.pageInfo.Extinfo.tabConfig.zdy4_name}`,
                src: this.pageInfo.Extinfo.tabConfig.zdy4_icon
                  ? this.pageInfo.Extinfo.tabConfig.zdy4_icon
                  : icons[5],
                type: "link",
                url: `${this.pageInfo.Extinfo.tabConfig.zdy4_link}`,
              });
            }
          }
          this.list = tmp;
        }
      });
  },
};
</script>
<style lang="css" scoped>
.btn-layer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92%;
  margin: 0 auto;
  margin-top: 0.2rem;
}
.btn-layer .icon-layer {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-layer .icon-layer .icon {
  /* width: 0.88rem;
  height: 0.88rem; */
  width: 64%;
}
.btn-layer .icon-layer .icon > img {
  display: block;
  width: 100%;
}
.btn-layer .icon-layer .name {
  font-size: 12px;
  color: #636a7a;
  text-align: center;
  line-height: 0.3rem;
  margin-top: 0.1rem;
}
.scrim-layer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
}
.box-layer {
  position: relative;
  width: 6rem;
  height: 7rem;
  background-color: #fff;
  border-radius: 0.2rem;
  top: 50%;
  margin-top: -3.5rem;
  left: 50%;
  margin-left: -3rem;
  padding: 0.2rem;
}
.box-layer .item-layer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0.2rem;
  top: 0.2rem;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.box-layer .item-layer .item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.1rem;
}
.box-layer .item-layer .item > img {
  width: 1.8rem;
  height: 1.1rem;
}
.box-layer .item-layer .item .right-layer {
  flex: 1;
  margin-left: 0.2rem;
}
.box-layer .item-layer .item .right-layer .title {
  color: #333333;
  line-height: 0.6rem;
  font-size: 0.3rem;
}
.box-layer .item-layer .item .right-layer .mobile {
  font-size: 0.26rem;
  color: #f2aa2e;
  background: #f5f5f5
    url("https://assets.rurushishi.com/yq-rs-make/huafa/icon_mobile.png")
    no-repeat left 8px center;
  background-size: 0.24rem 0.24rem;
  width: 1.3rem;
  border-radius: 4px;
  margin-top: 5px;
  padding: 6px 8px 6px 0.48rem;
}
.close_btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 0.8rem;
  height: 0.8rem;
  background: url("https://assets.rurushishi.com/yq-rs-wx/components/showimg/close.png")
    no-repeat center center;
  background-size: 0.6rem 0.6rem;
  z-index: 11;
}
.box-layer.animation {
  animation: zoomIn 0.8s;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}
</style>